import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {
  Button,
  Card,
  CardContent,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  MenuItem,
  TextField,
  Typography,
} from '@material-ui/core';

import api from '../../../services/api';

const useStyles = makeStyles((t) => ({
  root: {
    padding: t.spacing(4),
  },
  card: {
    marginBottom: t.spacing(2),
    cursor: 'pointer',
  },
  open: {
    borderLeft: '6px solid #ef8b22',
  },
  closed: {
    borderLeft: '6px solid #43a047',
  },
  msg: {
    padding: 12,
    margin: '8px 0',
    background: '#f6f8fa',
    borderRadius: 8,
  },
}));

const fmt = (d) => (d ? new Date(d).toLocaleString('pt-BR') : '');

export default function SolicitacoesPDV() {
  const c = useStyles();

  const [rows, setRows] = useState([]);
  const [det, setDet] = useState(null);
  const [status, setStatus] = useState('A');
  const [ini, setIni] = useState('');
  const [fim, setFim] = useState('');
  const [resposta, setResposta] = useState('');
  const [nroosFiltro, setNroosFiltro] = useState('');
  const [novo, setNovo] = useState(false);
  const [guias, setGuias] = useState([]);
  const [novoGuia, setNovoGuia] = useState('');
  const [novoAssunto, setNovoAssunto] = useState('');
  const [novaDescricao, setNovaDescricao] = useState('');
  const [novaOs, setNovaOs] = useState('');
  const [salvando, setSalvando] = useState(false);
  const [erroNovo, setErroNovo] = useState('');
  const [novosAnexos, setNovosAnexos] = useState([]);
  const [anexosResposta, setAnexosResposta] = useState([]);
  const [enviandoResposta, setEnviandoResposta] = useState(false);

  

  const codempresa = Number(sessionStorage.getItem('codEmpresa') || 0);
  const codusuario = Number(sessionStorage.getItem('codUser') || 0);

  const load = async () => {
    const r = await api.get('/pdv/notificacoes', {
      params: {
        admin: 1,
        codempresa,
        status,
        datainicial: ini || undefined,
        datafinal: fim || undefined,
        nroos: nroosFiltro || undefined
      }
    });

    setRows(r.data || []);
  };
  useEffect(() => {
    load();
  }, []);

  const open = async (id) => {
    const r = await api.get(`/pdv/notificacoes/${id}`, {
      params: {
        codempresa,
      },
    });

    setDet(r.data);
    setAnexosResposta([]);
  };

  const send = async () => {
    const mensagem = resposta.trim();

    if (!mensagem && anexosResposta.length === 0) return;
    if (mensagem.length > 4000) return;

    setEnviandoResposta(true);
    try {
      const r = await api.post(
        `/pdv/notificacoes/${det.mestre.codnotificacao}/mensagens`,
        {
          codempresa,
          codusuario,
          mensagem: mensagem || 'Anexo enviado.',
          origem: 'O',
        }
      );

      const codmensagem = r.data && r.data.codmensagem;
      for (const arquivo of anexosResposta) {
        const formData = new FormData();
        formData.append('arquivo', arquivo);
        if (codmensagem) formData.append('codmensagem', String(codmensagem));
        await api.post(`/pdv/notificacoes/${det.mestre.codnotificacao}/anexos`, formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
        });
      }

      setResposta('');
      setAnexosResposta([]);
      await open(det.mestre.codnotificacao);
      await load();
    } finally {
      setEnviandoResposta(false);
    }
  };

  const close = async () => {
    await api.patch(
      `/pdv/notificacoes/${det.mestre.codnotificacao}/fechar`,
      {
        codempresa,
        codusuario,
      }
    );

    setDet(null);
    load();
  };


  const abrirNova = async () => {
    setErroNovo('');
    try {
      const r = await api.get('/pdv/notificacoes/guias', { params: { codempresa } });
      setGuias(r.data || []);
      setNovoGuia('');
      setNovosAnexos([]);
      setNovo(true);
    } catch (e) {
      setErroNovo(e.response?.data?.error || 'Não foi possível carregar os guias.');
      setNovo(true);
    }
  };

  const criarParaGuia = async () => {
    const destino = guias.find((g) => String(g.codusuario) + ':' + String(g.codvendedor) + ':' + String(g.codguia) === novoGuia);
    if (!destino || (!Number(destino.codguia) && !Number(destino.codvendedor)) || !novoAssunto.trim() || !novaDescricao.trim()) {
      setErroNovo('Informe o guia, o assunto e a mensagem.');
      return;
    }

    setSalvando(true);
    setErroNovo('');
    try {
      let oss = [];
      if (novaOs.trim()) {
        const r = await api.get('/pdv/notificacoes/os/pesquisar', {
          params: { codempresa, q: novaOs.trim() }
        });
        const osExata = (r.data || []).find(
          (o) => String(o.nroos) === String(Number(novaOs))
        );
        if (!osExata) {
          setErroNovo(`OS ${novaOs} não encontrada.`);
          setSalvando(false);
          return;
        }
        oss = [osExata.codos];
      }

      const criada = await api.post('/pdv/notificacoes', {
        codempresa,
        codusuario,
        codguia: Number(destino.codguia) || 0,
        codvendedor: Number(destino.codvendedor) || 0,
        codescala: 0,
        assunto: novoAssunto.trim(),
        descricao: novaDescricao.trim(),
        origem: 'O',
        tipo: 'OPERACIONAL',
        oss,
      });

      const codnotificacao = criada.data && criada.data.codnotificacao;
      if (codnotificacao && novosAnexos.length) {
        for (const arquivo of novosAnexos) {
          const formData = new FormData();
          formData.append('arquivo', arquivo);
          await api.post(`/pdv/notificacoes/${codnotificacao}/anexos`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
          });
        }
      }

      setNovo(false);
      setNovoGuia('');
      setNovoAssunto('');
      setNovaDescricao('');
      setNovaOs('');
      setNovosAnexos([]);
      await load();
    } catch (e) {
      setErroNovo(e.response?.data?.error || 'Não foi possível criar a notificação.');
    } finally {
      setSalvando(false);
    }
  };


  return (
    <div className={c.root}>
      <Grid container justifyContent="space-between" alignItems="center">
        <Typography variant="h3" gutterBottom>
          Central de Solicitações PDV
        </Typography>
        <Button variant="contained" color="primary" onClick={abrirNova}>
          Nova notificação para guia
        </Button>
      </Grid>

      {/* Filtros */}
      <Card>
        <CardContent>
          <Grid container spacing={2}>
            <Grid item md={2}>
              <TextField
                select
                fullWidth
                label="Status"
                value={status}
                onChange={(e) => setStatus(e.target.value)}
              >
                <MenuItem value="">Todos</MenuItem>
                <MenuItem value="A">Em aberto</MenuItem>
                <MenuItem value="F">Fechados</MenuItem>
              </TextField>
            </Grid>

            <Grid item md={2}>
              <TextField
                fullWidth
                type="date"
                label="De"
                InputLabelProps={{ shrink: true }}
                value={ini}
                onChange={(e) => setIni(e.target.value)}
              />
            </Grid>

            <Grid item md={2}>
              <TextField
                fullWidth
                type="date"
                label="Até"
                InputLabelProps={{ shrink: true }}
                value={fim}
                onChange={(e) => setFim(e.target.value)}
              />
            </Grid>

            <Grid item md={2}>
              <TextField
                fullWidth
                label="Nº OS"
                value={nroosFiltro}
                inputProps={{ inputMode: 'numeric' }}
                onChange={(e) => setNroosFiltro(e.target.value.replace(/\D/g, ''))}
                onKeyDown={(e) => { if (e.key === 'Enter') load(); }}
              />
            </Grid>

            <Grid item>
              <Button
                variant="contained"
                color="primary"
                onClick={load}
              >
                Pesquisar
              </Button>
            </Grid>
          </Grid>
        </CardContent>
      </Card>

      {/* Solicitações */}
      {rows.map((r) => (
        <Card
          key={r.codnotificacao}
          className={`${c.card} ${r.status === 'F' ? c.closed : c.open
            }`}
          onClick={() => open(r.codnotificacao)}
        >
          <CardContent>
            <Grid container justifyContent="space-between">
              <div>
                <Typography variant="h5">
                  #{r.codnotificacao} • {r.assunto}
                </Typography>

                <Typography>
                  {r.descricao}
                </Typography>

                <Typography variant="caption">
                  {r.usuarioabertura}
                  {' • '}
                  {fmt(r.datahoraabertura)}
                  {' • '}
                  Escala {r.codescala || '-'}
                  {' • '}
                  {r.qtdmsg || 0} mensagens
                  {' • '}
                  {r.qtdanexo || 0} anexos
                </Typography>
              </div>

              <Chip
                label={r.status === 'F' ? 'FECHADA' : 'EM ABERTO'}
                style={{
                  background:
                    r.status === 'F' ? '#e8f5e9' : '#fff3e0',
                }}
              />
            </Grid>
          </CardContent>
        </Card>
      ))}

      {/* Nova notificação iniciada pelo operacional */}
      <Dialog open={novo} onClose={() => !salvando && setNovo(false)} maxWidth="sm" fullWidth>
        <DialogTitle>Nova notificação para guia</DialogTitle>
        <DialogContent>
          <TextField
            select fullWidth margin="normal" label="Guia"
            value={novoGuia} onChange={(e) => setNovoGuia(e.target.value)}
          >
            <MenuItem value=""><em>Selecione...</em></MenuItem>
            {guias.map((g) => (
              <MenuItem key={`${g.codusuario}:${g.codvendedor}:${g.codguia}`} value={`${g.codusuario}:${g.codvendedor}:${g.codguia}`}>
                {g.nomeguia} (Usuário {g.codusuario})
              </MenuItem>
            ))}
          </TextField>
          <TextField
            fullWidth margin="normal" label="Nº OS (opcional)"
            value={novaOs} inputProps={{ inputMode: 'numeric' }}
            onChange={(e) => setNovaOs(e.target.value.replace(/\D/g, ''))}
            helperText="A notificação não depende de escala. Vincule uma OS somente quando necessário."
          />
          <TextField
            fullWidth margin="normal" label="Assunto" value={novoAssunto}
            inputProps={{ maxLength: 120 }}
            onChange={(e) => setNovoAssunto(e.target.value)}
          />
          <TextField
            fullWidth multiline rows={4} margin="normal" label="Mensagem"
            value={novaDescricao} inputProps={{ maxLength: 1000 }}
            helperText={`${novaDescricao.length}/1000 caracteres`}
            onChange={(e) => setNovaDescricao(e.target.value)}
          />

          <div style={{ marginTop: 12 }}>
            <input
              id="anexos-notificacao-guia"
              type="file"
              multiple
              style={{ display: 'none' }}
              onChange={(e) => setNovosAnexos(Array.from(e.target.files || []))}
            />
            <label htmlFor="anexos-notificacao-guia">
              <Button variant="outlined" color="primary" component="span" disabled={salvando}>
                Adicionar anexo
              </Button>
            </label>
            <Typography variant="caption" display="block" style={{ marginTop: 6 }}>
              {novosAnexos.length
                ? `${novosAnexos.length} arquivo(s): ${novosAnexos.map((a) => a.name).join(', ')}`
                : 'Nenhum arquivo selecionado. Limite de 15 MB por arquivo.'}
            </Typography>
          </div>

          {erroNovo && <Typography color="error" style={{ marginTop: 8 }}>{erroNovo}</Typography>}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setNovo(false)} disabled={salvando}>Cancelar</Button>
          <Button color="primary" variant="contained" onClick={criarParaGuia} disabled={salvando}>
            {salvando ? 'Enviando...' : 'Enviar ao guia'}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Detalhes da solicitação */}
      <Dialog
        open={!!det}
        onClose={() => setDet(null)}
        maxWidth="md"
        fullWidth
      >
        {det && (
          <>
            <DialogTitle>
              #{det.mestre.codnotificacao} • {det.mestre.assunto}
            </DialogTitle>

            <DialogContent>
              <Typography>
                
                Guia: {String(det.mestre.nomeguia || '').trim() || 'Destinatário não identificado'}
                {' | '}
                Status:{' '}
                {det.mestre.status === 'F'
                  ? 'Fechada'
                  : 'Em aberto'}
              </Typography>

              {/* OS relacionadas */}
              <Typography
                variant="h5"
                style={{ marginTop: 18 }}
              >
                OS relacionadas
              </Typography>

              {det.oss.map((o) => (
                <div key={o.codos}>
                  OS {o.nroos}
                  {' • '}
                  {o.titular}
                  {' • '}
                  Pax {o.totalpax}
                 
                </div>
              ))}

              {/* Conversa */}
              <Typography
                variant="h5"
                style={{ marginTop: 18 }}
              >
                Conversa
              </Typography>

              {det.mensagens.map((m) => (
                <div
                  className={c.msg}
                  key={m.codmensagem}
                >
                  <b>
                    {m.usuario}{' '}
                    ({m.origem === 'O' ? 'Operação' : 'Guia'})
                  </b>

                  <div>
                    {m.mensagem}
                  </div>

                  {(det.anexos || []).filter((a) => Number(a.codmensagem) === Number(m.codmensagem)).map((a) => (
                    <div key={a.codanexo} style={{ marginTop: 6 }}>
                      <a href={`${api.defaults.baseURL}${a.urlarquivo}`} target="_blank" rel="noopener noreferrer">
                        📎 {a.nomearquivo}
                      </a>
                    </div>
                  ))}

                  <small>
                    {fmt(m.datahoramensagem)}
                  </small>
                </div>
              ))}

              {/* Anexos */}
              {det.anexos.some((a) => !a.codmensagem) && (
                <>
                  <Typography variant="h5">
                    Anexos
                  </Typography>

                  {det.anexos.filter((a) => !a.codmensagem).map((a) => (
                    <div key={a.codanexo}>
                      <a
                        href={`${api.defaults.baseURL}${a.urlarquivo}`}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {a.nomearquivo}
                      </a>
                    </div>
                  ))}
                </>
              )}

              {/* Resposta */}
              {det.mestre.status === 'A' && (
                <TextField
                  fullWidth
                  multiline
                  rows={3}
                  margin="normal"
                  label="Responder ao guia"
                  value={resposta}
                  inputProps={{ maxLength: 4000 }}
                  helperText={`${resposta.length}/4000 caracteres`}
                  onChange={(e) =>
                    setResposta(e.target.value)
                  }
                />
              )}

              {det.mestre.status === 'A' && (
                <div style={{ marginTop: 8 }}>
                  <input
                    id="anexos-resposta-notificacao"
                    type="file"
                    multiple
                    accept="image/*,.pdf,.doc,.docx"
                    style={{ display: 'none' }}
                    onChange={(e) => setAnexosResposta(Array.from(e.target.files || []))}
                  />
                  <label htmlFor="anexos-resposta-notificacao">
                    <Button component="span" variant="outlined" color="primary">
                      Anexar arquivo
                    </Button>
                  </label>
                  {anexosResposta.map((a, i) => (
                    <Typography key={`${a.name}-${i}`} variant="body2" style={{ marginTop: 5 }}>
                      📎 {a.name}
                    </Typography>
                  ))}
                </div>
              )}
            </DialogContent>

            <DialogActions>
              <Button onClick={() => setDet(null)}>
                Voltar
              </Button>

              {det.mestre.status === 'A' && (
                <>
                  <Button
                    color="primary"
                    variant="contained"
                    onClick={send}
                    disabled={enviandoResposta || (!resposta.trim() && anexosResposta.length === 0)}
                  >
                    {enviandoResposta ? 'Enviando...' : 'Responder'}
                  </Button>

                  <Button
                    color="secondary"
                    variant="contained"
                    onClick={close}
                  >
                    Fechar solicitação
                  </Button>
                </>
              )}
            </DialogActions>
          </>
        )}
      </Dialog>
    </div>
  );
}